import styled from '@emotion/styled';
import { Accordion } from '@naf-simba/elements-accordion';
import { Typography } from '@naf-simba/building-blocks-typography';
import { colors, simbaStyled } from '@naf-simba/theme';
import { spacing } from '@naf/theme';

export const StyledHouseholdAccordion = simbaStyled(Accordion)(({ theme }) => ({
  marginBottom: theme.spacing('l'),

  "&:has(button[aria-expanded='true'])": {
    backgroundColor: theme.palette.simba.colors.secondary[100],
  },

  '&& button': {
    padding: `${theme.spacing('s')} ${theme.spacing('ml')} ${theme.spacing('s')} ${theme.spacing('l')}`,
  },

  "&& [role='region']": {
    padding: theme.spacing('s'),
    marginLeft: theme.spacing('l'),
    marginBottom: theme.spacing('s'),
  },
}));

export const PriceList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.space16};
  background-color: ${colors.secondary[100]};
  margin-top: ${spacing.space8};
`;

export const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.space4} 0;
`;

export const Person = styled(Typography)`
  flex: 1;
`;

export const Price = styled.div`
  flex: 1;
  text-align: right;
  margin-right: ${spacing.space32};
`;

export const TermsTitle = styled(Typography)`
  margin: ${spacing.space20} 0 -${spacing.space8};
`;

export const TermsContent = styled.div`
  margin-right: ${spacing.space24};
`;
